import React from 'react';
import Top from "../../../assets/images/top.png"
import Meat from "../../../assets/images/meat.png"
import Salad from "../../../assets/images/salad.png"
import Cheese from "../../../assets/images/cheese.png"
import Bottom from "../../../assets/images/bottom.png"

let Ingredient=props=>{
    let ingredient=null;
    switch(props.type){
        case "top":
            ingredient=<div><img src={Top} alt="" width="35%" style={{margin:'2px'}} /></div>
            break;
        case "meat":
            ingredient=<div><img src={Meat} alt="" width="35%" style={{margin:'2px'}} /></div>
            break;
        case "salad":
            ingredient=<div><img src={Salad} alt="" width="35%" style={{margin:'2px'}} /></div>
            break;
        case "cheese":
            ingredient=<div><img src={Cheese} alt="" width="35%" style={{margin:'2px'}} /></div>
            break;
        case "bottom":
            ingredient=<div><img src={Bottom} alt="" width="35%" /></div>
            break;
        default:
            ingredient=null;
            break
    }
    return ingredient;
}
export default Ingredient;